var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fadeImagewrapper"},[_c('transition',{attrs:{"name":"fade"}},[_vm._v(" "+_vm._s(_vm.srcImage)+" "),_c('span',{staticClass:"imageOverlay"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],attrs:{"src":require('@/' + _vm.srcImage + '')},on:{"load":_vm.onLoaded}}),_vm._v("  ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }